module.exports = __webpack_public_path__ + "img/iphone@2x.593b316e.png";